import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import { styled } from "@mui/material/styles";

export const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
  width: "100%",
  margin: "0 auto",
  backgroundColor: "#e0e0e0",
  color: "black",
  ".Mui-expanded": {
    backgroundColor: "#e0e0e0",
  },
  "&:before": {
    display: "none",
  },
}));

export const AccordionDetails = styled(MuiAccordionDetails)(() => ({
  backgroundColor: "#e0e0e0",
  color: "#3d3935",
  textTransform: "none",
  overflow: "hidden",
  transitionTimingFunction: "ease",
  "list-style": "none",
  padding: "0.8em",
  "padding-top": "0em",
}));

export const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary {...props} />
))(() => ({
  position: "relative",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  padding: 0,
  ".MuiAccordionSummary-content": {
    "justify-content": "space-between",
    "text-align": "center",
    "align-items": "center",
    margin: "0.75em",
    maxHeight: "30px",
  },
}));
